import React, { useEffect, useState } from 'react'

import { cl } from '../../../utilities/cl'

import ScrollContainer from '../../ScrollContainer'
import CollapsiblePlaylist from '../../CollapsiblePlaylist'
import SvgArrowDownLight from '../../SVG/ArrowDownLight'
import { isFunc } from '../../../utilities/isFunc'
import Song from '../SongsAll'
import SvgAudio from '../../SVG/Audio'
import SvgVideo from '../../SVG/Video'
import Empty from '../../ContentMusic/Empty'

const VideolistAllItem = ({
    id,
    name,
    songs,
    selected,
    markItems,
    variant,
    onClick,
    onOpen,
    onlyOne
}) => {
    const [opened, setOpened] = useState(false)
    const [loaded, setLoaded] = useState(false)
    const [trackPlaying, setTrackPlaying] = useState(0)
    const [isPlaying, setIsPlaying] = useState(false)
    const [isWatching, setIsWatching] = useState(false)
    const [audio, setAudio] = useState(new Audio())
    const [lastClickedPlayId, setLastClickedPlayId] = useState(-1)
    useEffect(() => {
        if (lastClickedPlayId === trackPlaying) {
            audio.addEventListener("canplaythrough", audio.play)
        }
    }, [audio])
    const className = cl(
        // "Playlists__item",
        "selectable-item",
        { "Videolist": [variant] },
        { "selected": selected.indexOf(id) !== -1 },
        { "highlighted": markItems.indexOf(id) !== -1 },
        { "opened": opened },
    )
    let songs_arr = Object.values(songs)
    let songs_size = 0
    let songs_duration = ""
    let songs_hour = 0
    let songs_minutes = 0
    let songs_seconds = 0
    let hours = 0
    let minutes = 0
    let songs_count = songs_arr.length
    songs_arr.map(song => songs_size += song.size)
    songs_size = `${Math.round(songs_size / 1024 / 1024)} Mb`
    songs_arr.map(song => {
        let duration_arr = song.cliptime.split(".")[0].split(":")
        songs_hour += Number(duration_arr[0])
        songs_minutes += Number(duration_arr[1])
        songs_seconds += Number(duration_arr[2])
    })
    if (songs_seconds % 60 >= 0) {
        minutes = Math.floor(songs_seconds / 60)
        songs_minutes += minutes
        songs_seconds = songs_seconds % 60
    }
    if (songs_minutes % 60 >= 0) {
        hours = Math.floor(songs_minutes / 60)
        songs_hour += hours
        songs_minutes = songs_minutes % 60
    }
    songs_duration = `${songs_hour}:${songs_minutes}:${songs_seconds}`
    const hClick = (event) => {
        if (isFunc(onClick)) {
            if (!event.target.closest(".__CollapsibleCard__buttons"))
                onClick({ id, name, name, selected }, event)
        }
    }
    const hOpen = (event) => {
        event.preventDefault()
        event.stopPropagation()
        setOpened(!opened)
        setLoaded(true)
        if (isFunc(onOpen)) {
            onOpen({ id, name, name, selected }, event)
        }
    }
    const hPause = () => {
        setIsPlaying(false)
        setIsWatching(false)
        audio.pause()
    }

    const hStop = () => {
        setIsPlaying(false)
        setIsWatching(false)
    }

    const hRewind = (totime) => {
        if (audio.currentTime > 0) {
            audio.currentTime = totime
        }
    }
    const hPlay = ({ trackId, filename }) => {
        if (trackId === trackPlaying) {
            setLastClickedPlayId(trackId)
            audio.play()
            setIsPlaying(true)
            setIsWatching(true)
        } else {
            setLastClickedPlayId(trackId)
            audio.pause()
            setTrackPlaying(trackId)
            setIsPlaying(true)
            setIsWatching(true)
            setAudio(new Audio(filename))
        }
    }

    return (
        <div>
            <div className={ `${className} CollapsibleCardPlaylist` } data-videolist-id={ id } onClick={ hClick }>
                <div className="Videolist__header CollapsibleCardPlaylist__header">
                    <div className="Videolists__grid CollapsibleCardPlaylist__title">
                        <div className="play">
                            <span>
                                <SvgVideo variant="dark-lg" size="sm1" title="Воспроизвести" />
                            </span>
                        </div>
                        <div className="name">
                            { name.length > 25 ? `${name.slice(0, 25)}…` : name }
                        </div>
                        <div className="tracks_count">{ songs_count }</div>
                        <div className="size">
                            { songs_size }
                        </div>
                        <div className="duration">
                            { songs_duration }
                        </div>
                    </div>
                    <div className="__CollapsibleCardPlaylist__buttons" onClick={ hOpen }>
                        <div className="CollapsibleCardPlaylist__open" >
                            <SvgArrowDownLight
                                variant="dark"
                                size="mr"
                                title={ opened ? "Свернуть" : "Развернуть" }
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="CollapsibleCardPlaylist__content">
                { (opened)
                    && <ScrollContainer size="md">
                        { songs_arr.length > 0 ? songs_arr.map((song, index) => {
                            return < Song
                                key={ song.id }
                                id={ song.id }
                                name={ song.name }
                                turn={ song.turn }
                                cliptime={ song.cliptime }
                                // selected={ selected_song }
                                ctime={ song.ctime }
                                tempo={ song.tempo }
                                songauthor_name={ song.songauthor_name }
                                player_name={ song.player_name }
                                album_name={ song.album_name }
                                genre_name={ song.genre_name }
                                year={ song.year }
                                variant={ (index % 2 == 0) ? "gray" : "" }
                                filename={ song.filename }
                                id_videolist={ id }
                                audio={ audio }
                                trackPlaying={ trackPlaying }
                                isPlaying={ isPlaying }
                                isWatching={ isWatching }
                                play={ hPlay }
                                pause={ hPause }
                                stop={ hStop }
                                rewind={ hRewind }
                                onlyOne={onlyOne}

                            />
                        })
                            : <Empty title="Тут пока нет видео"></Empty>

                        }
                    </ScrollContainer>
                }
            </div>
        </div>
    )
}

export default VideolistAllItem